unable to read source [project]/frontend/node_modules/src/code-decoder.ts